export default "__VITE_ASSET__gvnK5BJJ__"